
    import './styles.scoped.css';
    export default {
  "dropdown-content-wrapper": "awsui_dropdown-content-wrapper_9duf6_xkqba_149",
  "awsui-motion-fade-in-dropdown": "awsui_awsui-motion-fade-in-dropdown_9duf6_xkqba_1",
  "refresh": "awsui_refresh_9duf6_xkqba_170",
  "awsui-motion-fade-in-0": "awsui_awsui-motion-fade-in-0_9duf6_xkqba_1",
  "root": "awsui_root_9duf6_xkqba_195",
  "interior": "awsui_interior_9duf6_xkqba_228",
  "dropdown": "awsui_dropdown_9duf6_xkqba_149",
  "use-portal": "awsui_use-portal_9duf6_xkqba_238",
  "is-empty": "awsui_is-empty_9duf6_xkqba_314",
  "dropdown-drop-up": "awsui_dropdown-drop-up_9duf6_xkqba_321",
  "with-limited-width": "awsui_with-limited-width_9duf6_xkqba_325",
  "dropdown-drop-left": "awsui_dropdown-drop-left_9duf6_xkqba_328",
  "dropdown-drop-right": "awsui_dropdown-drop-right_9duf6_xkqba_331",
  "occupy-entire-width": "awsui_occupy-entire-width_9duf6_xkqba_334",
  "use-flexible-width": "awsui_use-flexible-width_9duf6_xkqba_337",
  "hide-block-border": "awsui_hide-block-border_9duf6_xkqba_345",
  "open": "awsui_open_9duf6_xkqba_354",
  "nowrap": "awsui_nowrap_9duf6_xkqba_363",
  "dropdown-content": "awsui_dropdown-content_9duf6_xkqba_149",
  "stretch-trigger-height": "awsui_stretch-trigger-height_9duf6_xkqba_374"
};
  